import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../state/store';
import * as weighingTransfersSlice from '../weighingTransfersSlice';
import { LrvText } from '../../../../common/components/LrvText/LrvText';
import { LrvModal } from '../../../../common/components/LrvModal/LrvModal';
import DotSpinner from '../../../../common/components/DotSpinner/DotSpinner';

import styles from './StockingDestinationInformation.module.scss';

interface Props {
  theme?: 'light' | 'dark';
}

export const StockingDestinationInformation = (props: Props) => {
  const { theme = 'dark' } = props;
  
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { showStockingDestinationModal, stockingDestination, isLoadingStockingDestination } = useSelector((state: RootState) => state.weighingTransfers);
  
  const onCloseModal = () => {
    dispatch(weighingTransfersSlice.setShowStockingDestinationModal(false));
  };

  const renderRow = (props: { value?: string; label: string }) => {
    const { label, value } = props;

    return (
      <tr>
        <td>
          <LrvText className={styles.bold} theme={theme} text={label} />
        </td>
        <td>
          <LrvText theme={theme} text={value} />
        </td>
      </tr>
    );
  };

  const renderBody = () => {
    return (
      <tbody className={styles.body}>
        {renderRow({ value: stockingDestination?.campusName, label: t('stockings.campus') })}
        {renderRow({ value: stockingDestination?.moduleName, label: t('stockings.module') })}
        {renderRow({ value: stockingDestination?.tankName, label: t('stockings.tank') })}
        {renderRow({ value: stockingDestination?.name, label: t('stockings.name') })}
        {renderRow({ value: stockingDestination?.code, label: t('stockings.productionCycle') })}
        {renderRow({ value: stockingDestination?.status ? t(`stockings.stockingStatuses.${stockingDestination?.status}`) : '', label: t('stockings.finishStockingLabels.status') })}
      </tbody>
    );
  };

  const renderTable = () => {
    return (
      <table className={styles.table}>
        {renderBody()}
      </table>
    );
  };

  const renderBodyModal = () => {
    if (isLoadingStockingDestination) {
      return (
        <div className={styles.spinner}>
          <DotSpinner theme='light' />
        </div>
      );
    }

    return renderTable();
  };

  return (
    <LrvModal
      theme={theme}
      title={t('stockings.finishStockingLabels.destinationStocking')}
      open={showStockingDestinationModal}
      destroyOnClose={true}
      onCancel={onCloseModal}
      onOk={onCloseModal}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      {renderBodyModal()}
    </LrvModal>
  );
};
